import '@updater-components/icon';
import template from './utilities-card.html';
import './utilities-card.global.css';

class UtilitiesCardController {
  getLogo(provider) {
    return provider.logo
      ? `//d30c45h9cuv4p4.cloudfront.net/utility_provider_logos/${
          provider.logo
        }.png`
      : `//d30c45h9cuv4p4.cloudfront.net/ico-${provider.kind}-gray-large.svg`;
  }
}

export const UtilitiesCardComponent = {
  template,
  controller: UtilitiesCardController,
  bindings: {
    providers: '<',
    utility: '@',
  },
};
